<template>
  <div class="page-learn-ability-test-landing-page">
    <img class="page-learn-ability-test-landing-page-bg"
         :src="require('@/pages/2020/LearnAbilityTest/assets/img/landing_bg.png')"
         alt=""
    />
    <div class="page-learn-ability-test-landing-page-btn"
         @click="handleLinkToBeginPage"
    >
      <div class="page-learn-ability-test-landing-page-btn-info">
        <span class="high-light">
          马上测试
        </span>
        <span>即将进入测试({{ timerData.seconds[1] }}s)</span>
      </div>
      <img :src="require('@/pages/2020/LearnAbilityTest/assets/img/landing_arrow.png')"
           alt=""
      />
    </div>
  </div>
</template>

<script>
  import { decorator, after } from 'ym-reporter-vue';
  import CountDown from '@/utils/count-down';

  export default {
    name: 'LearnAbilityTestLandingPage',
    data() {
      return {
        second: 3,
        timerData: {
          days: '00',
          hours: '00',
          minutes: '00',
          seconds: '10',
        },
      };
    },
    methods: {
      @decorator(after(function () {
        this.$reporter.report('MARKETING_LEARNABILITYTEST_BEGIN_CLICK');
      }))
      handleLinkToBeginPage() {
        this.$emit('show-begin-page');
      },
      @decorator(after(function () {
        this.$reporter.report('MARKETING_LEARNABILITYTEST_BEGIN_CLICK');
      }))
      initCountDown() {
        new CountDown({
          startTime: new Date().valueOf(),
          endTime: new Date().valueOf() + (1000 * 10),
          render: (data) => {
            this.timerData = data;
          },
          end: () => {
            this.$emit('show-begin-page');
          },
        });
      },
    },
    mounted() {
      this.$nextTick(() => {
        this.initCountDown();
      });
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .page-learn-ability-test {
    &-landing-page {
      box-sizing: border-box;
      width: 100%;
      height: 100%;
      position: relative;
      background: #242648;
    }
    &-landing-page-bg {
      display: block;
      width: 100%;
      height: 1312px;
    }
    &-landing-page-btn {
      position: absolute;
      bottom: 80px;
      right: 34px;
      width: 350px;
      height: 130px;
      display: flex;
      align-items: center;
      justify-content: center;
      background: linear-gradient(to right, #fff, #ebebff);
      box-shadow: 0 8px 12px 0 rgba(16, 18, 53, 0.4);
      border-radius: 0 40px 0 0;

      img {
        display: block;
        width: 72px;
        height: 50px;
      }

      &-info {
        height: 70px;
        margin-right: 24px;
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        color: #5f5f8d;
        font-size: 24px;
        line-height: 1;

        .high-light {
          margin-bottom: 14px;
          color: #1c1e4a;
          font-size: 36px;
          font-weight: 600;
        }
      }
    }
  }

</style>
